export const personBingoObjects = Array.of(
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Ammende mor',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Krangel mellom par',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Noen som løper',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Noen som leker med jojo/lekebil',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Barn som gråter',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Svetteringe',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Noen som drikker ø',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Stresset kasseansatt',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Sur kasseansatt',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Superblid kasseansatt',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Forelsket par',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Gjeng kollegaer på tur',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Tydelig solbrent',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Turban',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Burka',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Backpacker',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Noen på krykker',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Amerikaner',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Kid med iPa',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Strikking/hekling',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Kryssord',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Kortspill',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Guttegjeng på tur',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Jentegjeng på tur',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Minigolfbil på tur',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Folk på vei inn i loungen',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Går og spiser baguette/wrap',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Kansellert fly',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Utsatt fly',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Go to gate…',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Person på i rullestol',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Noen med rødt hår',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Bukkeskjegg',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Fullskjegg',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Mann i singlet',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Bare bart',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Rosa koffert',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Stor pondus',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Boblevest',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Blomstrete skjorte',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Hatt',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Skinnjakke',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Bright multi colour sneakers',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Lite skjerf i halsen',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Pilot',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Flyvertinne(off duty)',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Frie tær',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Scrunchie',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Høy prat i telefon',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'FaceTime',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Magetopp',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'LV-bag',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Adidas sko',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Tracksuit',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Capsen bakfrem',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Linbukse',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Kiosk',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Duty free',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Toalett',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Person som ropes opp på anlegget',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Personal-belonging opprop',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Noen med billetten i brystlomme',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Kyssing/klining',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Fly som letter',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Fly som lander',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Drikker cola',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Munnbind',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Afro',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Asiat',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Ansatt som rydder',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Dovas',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Rumpetaske',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Ser på serie/film',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Spiller mobilspill',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Flette(r)',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Nesering',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Sjokoladeplate/pose i hånda',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Leser fysisk avis',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Dreads',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Perlekjede',
    },
    {
        id: 1,
        description: 'any',
        imageRef: 'ref',
        crossed: false,
        label: 'Artig hodeplagg (stirreverdig)}',
    }
).map((value, index) => ({ ...value, id: index }))
